<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('despachos')">Despachos</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>Agregar Compras
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
           <label class="pr-6 pb-8">Fecha:</label>
        <Datepicker  v-model="form.fecha" :error="form.errors.fecha" class="pr-6 pb-8 w-full lg:w-6/6" format="YYYY-MM-DD H:i:s" required/>
         <select-input v-model="form.tipo" :error="form.errors.tipo" class="pr-6 pb-8 w-full lg:w-1/3" label="Tipo Gasolina" >
            <option :value="diesel" >Diesel Premium</option>
          </select-input>   
          <text-input v-model="form.numero_comprobante" :error="form.errors.numero_comprobante" class="pr-6 pb-8 w-full lg:w-1/3" label="Nº Comprobante" required/>  
          <text-input v-model="form.cantidad_tanqueada" :error="form.errors.cantidad_tanqueada" class="pr-6 pb-8 w-full lg:w-1/3" label="Total Galones" required/>
          <br><br><br><br><br>  <br><br><br><br><br><br><br><br><br><br><br><br>
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Agregar Despacho</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Datepicker from 'vuejs-datetimepicker'

export default {
  metaInfo: { title: 'Add Despacho Maquinaria' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
     Datepicker
  },
  layout: Layout,
  props: {
    maquinarias: Array,
    proyectos: Array,
    conductores: Array,


  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        fecha: null,
        numero_comprobante: null,
        tipo: 'diesel',
        cantidad_tanqueada: null,
              }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('despachosmaquinaria.store'))
    },
  },
}
</script>
